import { Modal } from 'app/components/Modal';
import { useStore } from 'app/context';
import { observer } from 'mobx-react';
import { JpgHandlungsempfehlungen } from './JpgThemenContent';
import { AgenturModel } from 'app/models/agentur.model';
import { AgtBranchenplanungKeysField } from 'app/components/anwendungen/branchenplanung/AgtBranchenplanungKeysField';
import { useEffect } from 'react';
import Widget from 'app/components/common/Widget';

interface IJpgFocusThemaReadModal {
	agt?: AgenturModel;
	year?: number;
}
export const JpgFocusThemaReadModal = observer((props: IJpgFocusThemaReadModal) => {
	const { uiStore, documentUiStore, jpgThemenUiStore } = useStore();
	const f = documentUiStore.currentFocusThemaEdit;
	const agt = props.agt;
	const year = props.year;
	if (!agt || !year) {
		return null;
	}
	const themen = jpgThemenUiStore.getThemenByYear(year);
	const def = themen.find((t) => t.keyThema === f?.key);

	const onCancel = () => {
		uiStore.hideModal(uiStore.modalIds.jpgThemaView);
	};

	// Close modal if data is missing - use useEffect to avoid state updates during render
	useEffect(() => {
		if (!def || !f) {
			onCancel();
		}
	}, [def, f]);

	if (!def || !f) {
		return null;
	}

	return (
		<Modal modalId={uiStore.modalIds.jpgThemaView} title={`${def.group} - ${def.thema}`} modifier="is-form-modal" onClose={onCancel}>
			{def && f && (
				<>
					<div className="content">
						<strong>{def.thema}</strong>
						<p>{def.byLine && def.byLine}</p>
					</div>
					{f.notiz && (
						<Widget title="Notiz" disableCollapse={true}>
							<div className="content">
								<p>{f.notiz}</p>
							</div>
						</Widget>
					)}

					{def.bpKeys && def.bpKeys.length > 0 && (
						<div className="grid pad-top-1rem">
							<AgtBranchenplanungKeysField agt={agt} year={year} bpKeys={def.bpKeys} editMode={false} />
						</div>
					)}
					{def.dataComponent && (
						<>
							<div className="pad-top-1rem pad-bottom-1rem">
								<strong>Übersicht Daten</strong>
							</div>
							{def.dataComponent(agt, year)}
						</>
					)}
					{def.textComponent && <div className="pad-top-1rem">{def.textComponent}</div>}
					{def.handlungsEmpfehlungen && (
						<div className="pad-top-1rem">
							<JpgHandlungsempfehlungen handlungsEmpfehlungen={def.handlungsEmpfehlungen} />
						</div>
					)}
				</>
			)}
		</Modal>
	);
});
